//These constant values are based on the enum and should not change
export const UNASSIGNED_STATUS = 0
export const ASSIGNED_STATUS = 1
export const INPROGRESS_STATUS = 2
export const DELAYED_STATUS = 3
export const COMPLETED_STATUS = 4


const statuses = ['Unassigned', 'Assigned', 'InProgress', 'Delayed', 'Complete', 'Reassigned']
const iconIdOptions = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
/*
 *  For these status strings, we want to display them in the UI dropdown with slightly different wordings.
 */
function parseStatus(inputStatus){
    if(inputStatus === "InProgress")
        return "In Progress"
    if(inputStatus === "Complete")
        return "Completed"
    return inputStatus
}


function prettyDate(dateString){
    if(dateString === '0001-01-01T00:00:00'){
        return "None"
    }
    const d = new Date(dateString)
    const dtf = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' })
    return dtf.format(d);
}
function isoDateToYMD (longDateString){
    if(!longDateString){
        return null
    }
    const date = new Date(longDateString);
    const y = date.getFullYear();
    let m  = date.getMonth()+1;
    let d = date.getDate();

    if (d < 10) {
        d = '0' + d;
    }
    if (m < 10) {
        m = '0' + m;
    }
    const str = y+'-' + m + '-'+d
    return str
}
function ymdToISODate(ymdString){
    if(!ymdString){
        return null
    }
    const date = new Date(ymdString)
    return date.toISOString();
}
function makeTagString(jobTask){
    let tagString = ''
    if(jobTask.jobTaskTags && Array.isArray(jobTask.jobTaskTags)){
        jobTask.jobTaskTags.forEach((jtt) =>{
            if(!(jtt.tag && jtt.tag.name)){
                return
            }
            tagString = tagString.concat(jtt.tag.name + '\n')
        })
    }
    if(tagString === ''){
        tagString = 'None'
    }
    return tagString
}
function chopAddress(address) {
    const split = address.split(",")
    if (split.length >= 2) {
        return split[0] + "," + split[1]
    } else {
        return address
    }
}

function display(tasks) {
    const displayTasks = new Array(tasks.length);
    for (const i in tasks) {
        const jobTask = tasks[i];
        if (jobTask.scheduledDate) {
            jobTask.prettyScheduledDate = prettyDate(jobTask.scheduledDate)
        } else {
            jobTask.prettyScheduledDate = "None"
        }
        jobTask.tagString = makeTagString(jobTask)
        jobTask.twoTripString = jobTask.twoTrip ? "Yes" : "No"
        jobTask.routeName = (jobTask.route && jobTask.route.name) ? jobTask.route.name : 'None'
        jobTask.displayAddress = chopAddress(jobTask.address)
        jobTask.displayStatus = parseStatus(jobTask.status)
        displayTasks[i] = {
            jobTask: jobTask,
        }
    }
    return displayTasks
}

export default {
    display,
    chopAddress,
    isoDateToYMD,
    ymdToISODate,
    parseStatus,
    statuses,
    iconIdOptions,
    DELAYED_STATUS,
    UNASSIGNED_STATUS,
    ASSIGNED_STATUS,
    COMPLETED_STATUS,
    INPROGRESS_STATUS
}

